import Axios from 'axios';
import CryptoJS from 'crypto-js';
import { v4 as uuidv4 } from 'uuid';
import { SHAKEY } from '../../Components/constants/CommonConstants';
import { Store } from '../Store';
import { getTokenFromStore } from '../../utils/Utils';

const IMPLIFY_VERSION_V1 = 'v1';
const IMPLIFY_VERSION_V2 = 'v2';

// eslint-disable-next-line react-hooks/rules-of-hooks
export async function getCommonHeaders(uniqueIdForLogs, authTokenNeeded = true, apiObj = {}) {
    const store = Store.getState();
    const tenantName = store?.CommonStore?.linkParams?.tenant;
    if (!authTokenNeeded) {
        return {
            // 'Access-Control-Allow-Headers': 'Content-Type',
            'ggh-traceid': store?.CommonStore?.uniqTraceIdForLog,
            'ggh-senderid': CryptoJS.AES.encrypt('implifyuser', SHAKEY)
        };
    }
    let authToken = {
        'Access-Control-Allow-Headers': 'Content-Type,Authorization,',
        'ggh-senderid': CryptoJS.AES.encrypt('implifyuser', SHAKEY),
        uniqueIdForLogs,
        authorization: getTokenFromStore(store)?.token,
        'x-api-key': getTokenFromStore(store)?.apiKey
    };
    // Conditionally add 'x-tr-if' header only if it has a value
    if (tenantName) {
        authToken['X-Tenant-ID'] = tenantName;
    }
    return authToken;
}

export function getFullURL(apiVersion, url, pathsList = null, customEndPoint = '') {
    let apiEndPointURL = customEndPoint || `${process.env.REACT_APP_API_URL}/${apiVersion === 2 ? IMPLIFY_VERSION_V2 : IMPLIFY_VERSION_V1}`;
    // In API BASE URL - DO NOT PUT '/' at the END
    let fullURL = apiEndPointURL + '/' + url;
    if (pathsList) {
        for (const path of pathsList) {
            fullURL = fullURL + '/' + path;
        }
    }
    return fullURL;
}

export async function makeAPICall(payload) {
    let { apiObj, cutomURL, requestObj, queryParams, pathsList, customHeaders, offline, queueNo } = payload;
    const uniqueIdForLogs = uuidv4();

    const fullURL = getFullURL(apiObj.apiVersion, apiObj.customURLNeeded ? cutomURL : apiObj.url, pathsList, apiObj.customEndPoint);

    let response = {};
    if (apiObj?.isBlobStorageAPI) {
        const blobParams = new URLSearchParams(process.env.REACT_APP_BLOB_STORAGE_TOKEN);
        const axiosObj = {
            method: 'GET',
            url: fullURL,
            params: Object.fromEntries(blobParams),
            responseType: 'text' // or 'blob' for binary files
        };
        response = await Axios.request(axiosObj);
    } else {
        let headers = await getCommonHeaders(uniqueIdForLogs, apiObj.authTokenNeeded, payload);
        if (customHeaders) {
            headers = { ...headers, ...customHeaders };
        }

        let axiosObj = {
            method: apiObj.method,
            url: fullURL,
            data: requestObj,
            params: queryParams,
            validateStatus: false
        };
        if (!apiObj?.hideHeaders) {
            axiosObj = {
                ...axiosObj,
                headers: headers
            };
        }

        response = await Axios.request(axiosObj);
    }

    return { ...response?.data, offline: offline, statusCode: response.status, queueNo: queueNo };
    // This will not happen bcz if invalid, it will throw error
}

export function checkInternetConnectivity() {
    return navigator.onLine;
}

// This constant is used for tests - spyOn and also for segregation of logic from sagas_old.js
const callAPIFunctions = {
    callAPI: makeAPICall,
    checkInternet: checkInternetConnectivity,
    headers: getCommonHeaders
};

export default callAPIFunctions;
